module.exports = __webpack_public_path__ + "img/100.2.da9d8bb3.png";